import ServicePage from "../Common/ServicePage";

// Drainage Cleaning specific services
const drainageCleaningServices = [
  { 
    id: 1, 
    name: 'Basic Drainage Cleaning', 
    provider: 'DrainClear Experts', 
    image: 'https://placehold.co/600x400?text=Basic+Drain+Cleaning', 
    rating: 4.8, 
    reviews: 450, 
    price: 350, 
    category: 'Basic Cleaning' 
  },
  { 
    id: 2, 
    name: 'Deep Drainage Cleaning', 
    provider: 'DeepDrain Professionals', 
    image: 'https://placehold.co/600x400?text=Deep+Drain+Cleaning', 
    rating: 4.9, 
    reviews: 300, 
    price: 700, 
    category: 'Deep Cleaning' 
  },
  { 
    id: 3, 
    name: 'Kitchen Drain Cleaning', 
    provider: 'KitchenDrain Solutions', 
    image: 'https://placehold.co/600x400?text=Kitchen+Drain', 
    rating: 4.75, 
    reviews: 380, 
    price: 300, 
    category: 'Kitchen Drain' 
  },
  { 
    id: 4, 
    name: 'Bathroom Drain Cleaning', 
    provider: 'BathDrain Specialists', 
    image: 'https://placehold.co/600x400?text=Bathroom+Drain', 
    rating: 4.82, 
    reviews: 420, 
    price: 400, 
    category: 'Bathroom Drain' 
  },
  { 
    id: 5, 
    name: 'Sewer Line Cleaning', 
    provider: 'SewerPro Services', 
    image: 'https://placehold.co/600x400?text=Sewer+Line', 
    rating: 4.85, 
    reviews: 250, 
    price: 900, 
    category: 'Sewer Line' 
  },
  { 
    id: 6, 
    name: 'Storm Drain Cleaning', 
    provider: 'StormDrain Experts', 
    image: 'https://placehold.co/600x400?text=Storm+Drain', 
    rating: 4.78, 
    reviews: 180, 
    price: 600, 
    category: 'Storm Drain' 
  },
  { 
    id: 7, 
    name: 'Floor Drain Cleaning', 
    provider: 'FloorDrain Professionals', 
    image: 'https://placehold.co/600x400?text=Floor+Drain', 
    rating: 4.81, 
    reviews: 220, 
    price: 280, 
    category: 'Floor Drain' 
  },
  { 
    id: 8, 
    name: 'Pipe Blockage Removal', 
    provider: 'PipeClear Solutions', 
    image: 'https://placehold.co/600x400?text=Pipe+Blockage', 
    rating: 4.83, 
    reviews: 350, 
    price: 450, 
    category: 'Pipe Blockage' 
  },
  { 
    id: 9, 
    name: 'Grease Trap Cleaning', 
    provider: 'GreaseTrap Experts', 
    image: 'https://placehold.co/600x400?text=Grease+Trap', 
    rating: 4.79, 
    reviews: 190, 
    price: 550, 
    category: 'Grease Trap' 
  },
  { 
    id: 10, 
    name: 'Emergency Drain Cleaning', 
    provider: 'QuickDrain Services', 
    image: 'https://placehold.co/600x400?text=Emergency+Drain', 
    rating: 4.86, 
    reviews: 150, 
    price: 800, 
    category: 'Emergency Service' 
  },
  { 
    id: 11, 
    name: 'Root Intrusion Removal', 
    provider: 'RootRemove Professionals', 
    image: 'https://placehold.co/600x400?text=Root+Removal', 
    rating: 4.77, 
    reviews: 120, 
    price: 750, 
    category: 'Root Removal' 
  },
  { 
    id: 12, 
    name: 'Drain Camera Inspection', 
    provider: 'DrainInspect Experts', 
    image: 'https://placehold.co/600x400?text=Drain+Inspection', 
    rating: 4.88, 
    reviews: 200, 
    price: 400, 
    category: 'Inspection' 
  }
];

const drainageCleaningCategories = ['Basic Cleaning', 'Deep Cleaning', 'Kitchen Drain', 'Bathroom Drain', 'Sewer Line', 'Storm Drain', 'Floor Drain', 'Pipe Blockage', 'Grease Trap', 'Emergency Service', 'Root Removal', 'Inspection'];

const packages = [
  { id: 1, title: "Basic Drainage Cleaning", rating: "4.8 (450 reviews)", price: 350, originalPrice: 450, icon: "🚰" },
  { id: 2, title: "Deep Drainage Cleaning", rating: "4.9 (300 reviews)", price: 700, originalPrice: 850, icon: "🌀" },
];

const miniServices = [
  { id: 101, title: "Kitchen Drain Cleaning", price: 300, icon: "🍳" },
  { id: 102, title: "Bathroom Drain Cleaning", price: 400, icon: "🚿" },
];

export default function DrainageCleaning() {
  return (
    <ServicePage
      serviceName="Drainage Cleaning"
      packages={packages}
      miniServices={miniServices}
      customServices={drainageCleaningServices}
      customCategories={drainageCleaningCategories}
      isCustomService={true}
    />
  );
}